import { createSlice } from "@reduxjs/toolkit";

export const themedata = createSlice({
    name: 'themedata',

    initialState: {
        theme: 'light',
    },

    reducers: {
        updatetheme: (state, themetype) => {
            state.theme = themetype.payload
        },
    }
})

export const {updatetheme} = themedata.actions
export default themedata.reducer